module.exports = __webpack_public_path__ + "img/address-sucess-icon.5dbfe26b.png";